module.exports = __webpack_public_path__ + "img/AppliedPrecision.9916d4bc.jpg";